import { useState } from 'react';

/**
 * @description This hook is used to delay moving to the next page so that loading indicators are visible for a minimum amount of time
 * @param delay - The delay in milliseconds
 * @returns {isDelaying, startTransition}
 */
export const useDelay = (delay = 1000) => {
	const [isDelaying, setIsDelaying] = useState(false);

	const startDelay = async (callback) => {
		setIsDelaying(true);
		const startTime = Date.now();

		await callback();

		const elapsed = Date.now() - startTime;
		const remainingDelay = Math.max(0, delay - elapsed);

		if (remainingDelay > 0) {
			await new Promise((resolve) => setTimeout(resolve, remainingDelay));
		}

		setIsDelaying(false);
	};

	return { isDelaying, startDelay };
};
